import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//竞赛管理相关API

const competitionManage = {

    //竞赛获奖
    competition: {

        initCombo: config => createAPI('/scoreManage/competition/initCombo', 'post', config),

        initRegistrationCombo: config => createAPI('/scoreManage/competition/initRegistrationCombo', 'post', config),

        save: config => createAPI('/scoreManage/competition/save', 'post', config),

        saveCompetitionRegistration: config => createAPI('/scoreManage/competition/saveCompetitionRegistration', 'post', config),

        deleteCompetitionRegistration: config => createAPI('/scoreManage/competition/deleteCompetitionRegistration', 'post', config),

        queryList: config => createAPI('/scoreManage/competition/queryList', 'post', config),

        queryListCompetitionRegistration: config => createAPI('/scoreManage/competition/CompetitionRegistration', 'post', config),

        exportCompetitionRegistration: config => createAPI('/scoreManage/competition/exportCompetitionRegistration', 'post', config),

        saveRec: config => createAPI('/scoreManage/competition/saveRec', 'post', config),

        queryRscList: config => createAPI('/scoreManage/competition/queryRscList', 'post', config),

        deletefile: config => createAPI('/scoreManage/competition/deletefile', 'post', config),

    },

    //教学成果
    achievement: {

        initCombo: config => createAPI('/scoreManage/achievement/initCombo', 'post', config),

        initRegistrationCombo: config => createAPI('/scoreManage/achievement/initRegistrationCombo', 'post', config),

        save: config => createAPI('/scoreManage/achievement/save', 'post', config),

        saveCompetitionRegistration: config => createAPI('/scoreManage/achievement/saveCompetitionRegistration', 'post', config),

        deleteAchievementRegistration: config => createAPI('/scoreManage/achievement/deleteAchievementRegistration', 'post', config),

        queryList: config => createAPI('/scoreManage/achievement/queryList', 'post', config),

        updateAchievement: config => createAPI('/scoreManage/achievement/updateAchievement', 'post', config),

        queryListAchievementRegistration: config => createAPI('/scoreManage/achievement/AchievementRegistration', 'post', config),

        exportCompetitionRegistration: config => createAPI('/scoreManage/achievement/exportCompetitionRegistration', 'post', config),

        saveRec: config => createAPI('/scoreManage/achievement/saveRec', 'post', config),

        queryRscList: config => createAPI('/scoreManage/achievement/queryRscList', 'post', config),

        deletefile: config => createAPI('/scoreManage/achievement/deletefile', 'post', config),

    },

    //比赛信息
    competitionInfo: {

        initCombo: config => createAPI('/competitionManage/competitionInfo/initCombo', 'post', config),

        save: config => createAPI('/competitionManage/competitionInfo/save', 'post', config),

        queryList: config => createAPI('/competitionManage/competitionInfo/queryList', 'post', config),

        del: config => createAPI('/competitionManage/competitionInfo/del', 'post', config),

        updateAuditState: config => createAPI('/competitionManage/competitionInfo/updateAuditState', 'post', config),

        queryAuditFlow: config => createAPI('/competitionManage/competitionInfo/queryAuditFlow', 'post', config),

    },

    //比赛申请
    competitionApply: {

        initCombo: config => createAPI('/competitionManage/competitionApply/initCombo', 'post', config),

        save: config => createAPI('/competitionManage/competitionApply/save', 'post', config),

        queryList: config => createAPI('/competitionManage/competitionApply/queryList', 'post', config),

        del: config => createAPI('/competitionManage/competitionApply/del', 'post', config),

        updateAuditState: config => createAPI('/competitionManage/competitionApply/updateAuditState', 'post', config),

        loadStuTable: config => createAPI('/competitionManage/competitionApply/loadStuTable', 'post', config),

        export: config => createAPI('/competitionManage/competitionApply/export', 'post', config),

        queryAuditFlow: config => createAPI('/competitionManage/competitionApply/queryAuditFlow', 'post', config),

    },

    //比赛申请
    stuAward: {

        initCombo: config => createAPI('/competitionManage/stuAward/initCombo', 'post', config),

        save: config => createAPI('/competitionManage/stuAward/save', 'post', config),

        queryList: config => createAPI('/competitionManage/stuAward/queryList', 'post', config),

        del: config => createAPI('/competitionManage/stuAward/del', 'post', config),

        loadStu: config => createAPI('/competitionManage/stuAward/loadStu', 'post', config),

        upload: config => createAPI('/competitionManage/stuAward/upload', 'post', config),

        loadFjTable: config => createAPI('/competitionManage/stuAward/loadFjTable', 'post', config),

        delAllFj: config => createAPI('/competitionManage/stuAward/delAllFj', 'post', config),

        delFj: config => createAPI('/competitionManage/stuAward/delFj', 'post', config),

        export: config => createAPI('/competitionManage/stuAward/export', 'post', config),

    },

    //获奖统计
    awardStatistics: {

        queryList: config => createAPI('/competitionManage/awardStatistics/queryList', 'post', config),

        initCombo: config => createAPI('/competitionManage/awardStatistics/initCombo', 'post', config),

    },
    eventInformation: {
        initCombo: config => createAPI('/competitionManage/eventInformation/initCombo', 'post', config),
        save: config => createAPI('/competitionManage/eventInformation/save', 'post', config),
        queryList: config => createAPI('/competitionManage/eventInformation/queryList', 'post', config),
        queryRscList: config => createAPI('/competitionManage/eventInformation/queryRscList', 'post', config),
        saveRec: config => createAPI('/competitionManage/eventInformation/saveRec', 'post', config),
        deletefile: config => createAPI('/competitionManage/eventInformation/deletefile', 'post', config),
        del: config => createAPI('/competitionManage/eventInformation/del', 'post', config),
    },
    teamProjectProposal: {
        initCombo: config => createAPI('/competitionManage/teamProjectProposal/initCombo', 'post', config),
        save: config => createAPI('/competitionManage/teamProjectProposal/save', 'post', config),
        queryList: config => createAPI('/competitionManage/teamProjectProposal/queryList', 'post', config),
        del: config => createAPI('/competitionManage/teamProjectProposal/del', 'post', config),
        submit: config => createAPI('/competitionManage/teamProjectProposal/submit', 'post', config),
        queryTdxxList: config => createAPI('/competitionManage/teamProjectProposal/queryTdxxList', 'post', config),
        queryTdgcList: config => createAPI('/competitionManage/teamProjectProposal/queryTdgcList', 'post', config),
        updateAuditState: config => createAPI('/competitionManage/teamProjectProposal/updateAuditState', 'post', config),
        noticeTeacher: config => createAPI('/competitionManage/teamProjectProposal/noticeTeacher', 'post', config),
    },
    teamSummary: {
        initCombo: config => createAPI('/competitionManage/teamSummary/initCombo', 'post', config),
        queryList: config => createAPI('/competitionManage/teamSummary/queryList', 'post', config),
    },
    competitionAwards: {
        initCombo: config => createAPI('/competitionManage/competitionAwards/initCombo', 'post', config),
        queryList: config => createAPI('/competitionManage/competitionAwards/queryList', 'post', config),
        save: config => createAPI('/competitionManage/competitionAwards/save', 'post', config),
        submit: config => createAPI('/competitionManage/competitionAwards/submit', 'post', config),
        updateAuditState: config => createAPI('/competitionManage/competitionAwards/updateAuditState', 'post', config),
    },
    competitionSummary: {
        initCombo: config => createAPI('/competitionManage/competitionSummary/initCombo', 'post', config),
        queryList: config => createAPI('/competitionManage/competitionSummary/queryList', 'post', config),
    }
};

export default competitionManage;



// WEBPACK FOOTER //
// ./src/api/modules/competitionManage.js